var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4375 12H4.0625C4.51191 12 4.875 11.617 4.875 11.1429C4.875 10.6688 4.51191 10.2857 4.0625 10.2857H2.4375C1.98885 10.2857 1.625 9.90188 1.625 9.42857V2.57143C1.625 2.09812 1.98885 1.71429 2.4375 1.71429H4.0625C4.51191 1.71429 4.875 1.33045 4.875 0.857143C4.875 0.383839 4.51191 0 4.0625 0H2.4375C1.09129 0 0 1.15125 0 2.57143V9.42857C0 10.8482 1.09129 12 2.4375 12ZM12.8172 5.53125L9.1584 1.88839C8.9813 1.7122 8.72168 1.66406 8.49824 1.76534C8.27473 1.86704 8.12982 2.09936 8.12982 2.35596L8.12749 4.28454L4.87749 4.28451C4.42833 4.28451 4.06449 4.66835 4.06449 5.14165V6.85594C4.06449 7.32924 4.42859 7.71308 4.87749 7.71308L8.12749 7.71311L8.12982 9.61757C8.12982 9.87413 8.27473 10.1064 8.49824 10.2082C8.72176 10.3095 8.98143 10.2613 9.1584 10.0851L12.8172 6.44229C13.0609 6.225 13.0609 5.775 12.8172 5.53125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign-in.13e789d3775b115268da1dd340dabe4a.svg";
export { ForwardRef as ReactComponent };